import * as types from '../types';

export default {
  [types.GET_CUSTOM_TYPE](state, data) {
    state.customType = data;
  },
  [types.GET_CUSTOM_LEVEL](state, data) {
    state.customLevelList = data;
  },
  [types.GET_CONTACTS_TYPE](state, data) {
    state.contactsType = data;
  },
  [types.GET_VISIT_TYPE](state, data) {
    state.visitType = data;
  },
  [types.GET_CRM_AUTH](state, data) {
    state.crmAuth = data;
  },
  [types.GET_CLERK_LIST](state, data) {
    state.clerkList = data;
  },
  [types.GET_SIGNIN_TEAMS](state, data) {
    state.signinTeams = data;
  },
  [types.GET_SERVICE_TYPE](state, data) {
    state.serviceType = data.results;
  },
  [types.GET_CLUE_SOURCE](state, data) {
    state.clueSource = data.results;
  },
  [types.GET_INVALID_REASON](state, data) {
    state.invalidReason = data.results;
  },
  [types.GET_INVESTIGATION_NATURE](state, data) {
    state.investigationNature = data.results;
  },
  [types.GET_INVESTIGATION_CATEGORY](state, data) {
    state.investigatType = data.results;
  },
  [types.GET_RECEPTION_LEVEL](state, data) {
    state.receptionLevel = data.results;
  },
  [types.GET_PROJECT_STAGE](state, data) {
    state.projectStage = data.results;
  },
  [types.GET_MODE_TYPE](state, data) {
    state.modeTypeList = data.results;
  },
  [types.GET_SETTLEMENT_SOURCE](state, data) {
    state.settlementList = data.results;
  },
};
